module.exports = __webpack_public_path__ + "img/25800.a9f9cce7.jpg";